import * as React from 'react';
import { FrontPageBox } from './Box';
import { BrandTagline, BrandTitle } from './Brand';

export const BrandBox = () => (
  <FrontPageBox>
    <BrandTitle> apace </BrandTitle>
    <BrandTagline> Solutions </BrandTagline>
  </FrontPageBox>
);
